import { NewAlertType } from './new-alert-type';

export class NewAlertModel {
    id: string;
    type: NewAlertType;
    title: string;
    message: string;
    autoClose: boolean;
    keepAfterRouteChange: boolean;
    fade: boolean;

    constructor(init?: Partial<NewAlertModel>) {
        Object.assign(this, init);

        if(!init.hasOwnProperty('autoClose')){
            this.autoClose = true;
        }
    }
}